<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="800">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <div>
                    <h4>{{ zone.name }}'s Spot</h4>
                    <v-btn class="me-3" color="black" size="small" @click="addSpotDialogSwitch = true">
                        Add Spot
                    </v-btn>
                </div>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-table>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="spot in spots" v-if="!loading && spots" :key="spot.id"
                                class="text-left">
                                <td>{{ spot.name }}</td>
                                <td>{{ types[spot.type].name }}</td>
                                <td>{{ formatDateTime(spot.created_at) }}</td>
                                <td>
                                    <v-btn-group density="compact" divided variant="outlined">
                                        <v-btn class="text-warning" prepend-icon="mdi-account-switch"
                                               size="x-small" @click="editSpot(spot)">Edit
                                        </v-btn>
                                        <v-btn class="text-error" prepend-icon="mdi-account-multiple-minus"
                                               size="x-small" title="Remove User"
                                               @click="deleteSpot(spot)">Remove
                                        </v-btn>
                                    </v-btn-group>
                                </td>
                            </tr>
                            <tr v-else>
                                <td v-if="loading" colspan="5">
                                    <v-progress-circular color="primary" indeterminate/>
                                </td>
                                <td v-else colspan="7">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>

                <v-row v-if="totalPages > 1" justify="center">
                    <v-col cols="8">
                        <v-pagination
                            v-model="currentPage"
                            :length="totalPages"
                            class="my-4"
                            density="compact"
                            @update:model-value="fetchSpots"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button"
                       @click="$emit('update:modelValue',false)">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Create v-if="addSpotDialogSwitch" v-model="addSpotDialogSwitch" :allSport="spots"
            :types="types" :zone="zone" @update-spots="updateSpots"/>

    <Edit v-if="EditSpotDialogSwitch" v-model="EditSpotDialogSwitch" :allSport="spots" :spot="selectedSpot"
          :types="types" :zone="zone" @update-spot="updateSpot"/>

</template>

<script setup>
import {send} from "@/composables/apiClient";
import {ref, reactive, onMounted} from "vue";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Create from "@/components/dialogs/companies/Spots/Create.vue";
import Edit from "@/components/dialogs/companies/Spots/Edit.vue";
import {formatDateTime} from "@/composables/useTimezone";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    zone: Object,
});

const emits = defineEmits(['update:modelValue']);
const addSpotDialogSwitch = ref(false);
const EditSpotDialogSwitch = ref(false);
const dialogSwitch = ref(props.modelValue);
const selectedSpot = ref(null);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const spots = ref([]);
const types = ref([
    {id: 0, name: 'Parking Spot'},
    {id: 1, name: 'Ramp'},
    {id: 2, name: 'Reserved Spot'},
    {id: 3, name: 'Waiting Area'},
    {id: 4, name: 'No Parking Zone'}
]);


onMounted(() => {
    fetchSpots();
});

const fetchSpots = () => {
    loading.value = true;
    send('get', `companies/locations/zones/${props.zone.id}/spots?page=${currentPage.value}`)
        .then((response) => {
            spots.value = response.data.data.spots.data;
            totalPages.value = response.data.data.spots.last_page;
            currentPage.value = response.data.data.spots.current_page;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Zones could not be loaded', 'error')
        })
}

const updateSpots = (location) => {
    spots.value.unshift(location);
}
const editSpot = (spot) => {
    selectedSpot.value = spot;
    EditSpotDialogSwitch.value = true;
}
const updateSpot = (updatedZone) => {
    spots.value.map((location, index) => {
        if (location.id === updatedZone.id) {
            spots.value[index] = updatedZone;
        }
    });
}
const deleteSpot = (spot) => {
    if (confirm(`Are you sure to remove spot "${spot.name}" from ${props.zone.name}?`)) {
        send('delete', `companies/locations/zones/${props.zone.id}/spots/${spot.id}`)
            .then((response) => {
                if (response.data.success) {
                    spots.value.map((item, index) => {
                        if (item.id === spot.id) {
                            spots.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error)
                showSnackbar(`"${zone.name}" user could not be deleted`, 'error')
            })
    }
}


</script>
